import script from "./InvestigationGeneralTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationGeneralTable.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationGeneralTable.vue?vue&type=style&index=0&id=08d5fcd3&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d5fcd3"]])

export default __exports__